import React from 'react';

export const Typography: React.FC = (props) => {
    return <div className={'dx-theme-material-typography'}>{props.children}</div>;
};
